import { Component, OnInit, DoCheck, ViewChild, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../services/events/dashboard.service';
import { StorageManager } from '../../common/storage-manager.class';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { MenuItem } from 'primeng/api';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';
import { url } from 'src/app/config/config';
import { logoDasboard } from 'src/app/config/imagenes';
import { TitleHeaderService } from 'src/app/services/title-header/title.header.service';
import { SlideMenu} from 'primeng/slidemenu';
import { environment } from 'src/environments/environment';
 import { version } from '../../../../package.json';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    providers: [MessageService]
})
export class DashboardComponent implements OnInit, DoCheck {

    @ViewChild('menu') menu_slide: SlideMenu;

    @HostListener('window:scroll', ['$event']) // for window scroll events
    onScroll(event) {
        this.menu_slide.hide();
    }

    public items: MenuItem[];
    public calidad_imagen: string;
    public fruto_hueso: string;
    public app_stock: string;
    public app_visitas: string;
    public brcgs: string;
    enac: string;
    global_gap: string;
    ifs: string;
    igp: string;
    certificado: string;
    planta:string;
    displayDocumentacion: boolean;
    titleDocumentacion: any;
    public url_doc: string = '';
    public version: string = version; //TODO pdte subir

    public showInfoUser = {};

    ngDoCheck(): void {
        this.dashboardEvent.revisarMenu();
        this.showImage();
        this.titleAnexo = this.location.path().replace("/dashboard/", "");
        this.titleAnexo = this.capitalize(this.titleAnexo);
    }
    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
    public expression = false;
    public displayImage = false;
    public contador = 0;
    public cols: any[] = [];
    public resultado: any[] = [];
    public registros: any;
    public click: Subscription;
    public es: any;
    public categoria = "";
    public date: Date = new Date();
    public fechaCadena = "";
    public displayAnexo = false;
    public titleAnexo = "";
    public dispplayContent = false;
    public sidebarMaxWidth: number = 100;
    public isSidebarOpen: boolean = false;
    public clientHeaderDialog: string;
    public showClientDialog: boolean = false;
    //public logoUrl: string = environment.logoUrl;
    public isOnline: boolean;
    public logo: string = '';
    public popupItems = [
        
        {
            label: 'Cerrar Sesión',
            icon: 'fa fa-sign-out',
            command: (): void => {
                StorageManager.deleteUser();
                // // localStorage.clear();
                this.router.navigate(['login']);
            }
        }
    ];

    public user = StorageManager.getUser() || {} as any;

    public clientes = {
        selected: null,
        filtered: [{ label: 'Cargando...', value: null }],
        values: []
    };

    public header: {
        title: string;
        subtitle: string;
    } = { title: 'VPE', subtitle: '' };

    public static createNavigation(router: Router) {
        router.navigate(['dashboard']);
    }

    constructor(private router: Router,
        public dashboardEvent: DashboardService,
        private route: ActivatedRoute,
        private location: Location,
        private messageService: MessageService,
        private ImageBaseService: ImageBaseService,
        private titleHeaderService: TitleHeaderService
    ) {
        this.showMySideBar();

        this.titleHeaderService.changeHeaderTitle().subscribe((rutas) => {
         
            if (rutas.titulo != null && (rutas.titulo as string).length > 1) {
                this.dashboardEvent.headerTitle = rutas.titulo;
                if (rutas.id == null) {
                    localStorage.removeItem('id_documento_registro');
                } else {
                    localStorage.setItem('id_documento_registro', rutas.id);
                }
                ;
            } else {
                if (this.dashboardEvent.headerTitle == null || this.dashboardEvent.headerTitle.length == 0) {
                    this.dashboardEvent.headerTitle = "Calidad Brio";
                } else {

                }

            }

        });


    }
    public menuItems() {
        this.items = [

            // {
            //     label: 'Revisiones',
            //     icon: 'pi pi-fw pi-file',
            //     command: (): void => {
            //         this.titleAnexo = this.location.path().replace("/dashboard/", "");
            //         let contarRutas = this.titleAnexo.split("/");
            //         this.displayAnexo = false;
            //         if (contarRutas.length != 1) {
            //             this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Tiene que estar en un documento para poder ver las revisiones' });

            //         } else {
            //             this.displayAnexo = true;
            //         }

            //     }
            // },
            {
                label: 'Mi perfil',
                icon: 'fa fa-user',
                command: (): void => {
                    this.dashboardEvent.headerTitle = "Mi perfil";
                    this.router.navigate(['dashboard/perfil']);
                    if (this.isSidebarOpen) {
                        this.isSidebarOpen = !this.isSidebarOpen;
                    }
                }
            },
            {
                label: 'Cerrar Sesión',
                icon: 'fa fa-sign-out',
                command: (): void => {
                    StorageManager.deleteUser();
                    // localStorage.clear();
                    this.router.navigate(['login']);
                }
            }
        ];
    }
    public menuItemsUser() {
        this.items = [
            {
                label: 'Mi perfil',
                icon: 'fa fa-user',
                command: (): void => {
                    this.dashboardEvent.headerTitle = "Mi perfil";
                    this.router.navigate(['dashboard/perfil']);
                    if (this.isSidebarOpen) {
                        this.isSidebarOpen = !this.isSidebarOpen;
                    }
                }
            },
            {
                label: 'Usuarios',
                icon: 'fa fa-users',
                command: (): void => {
                    this.dashboardEvent.headerTitle = "Control de usuarios";
                    this.router.navigate(['dashboard/usuarios']);
                    if (this.isSidebarOpen) {
                        this.isSidebarOpen = !this.isSidebarOpen;
                    }

                }
            },
            {
                label: 'Consultas logs',
                icon: 'fa fa-list',
                command: (): void => {

                        this.dashboardEvent.headerTitle = "Historial de acceso";
                        this.router.navigate(['dashboard/consultas']);
                        if (this.isSidebarOpen) {
                            this.isSidebarOpen = !this.isSidebarOpen;
                        }

                    
                }
            },
                      
           /*  {
                label: 'Territorio',
                icon: 'fa fa-map',
                command: (): void => {

                    if (this.location.path().includes('usuarios')) {

                        this.displayImage = true;
                        this.expression = true;
                        this.messageService.add({ severity: 'info', summary: 'Usuarios', detail: 'No disponible en esta sección', life: 500 });

                    } else {

                        this.titleAnexo = this.location.path().replace("/dashboard/", "");
                        let contarRutas = this.titleAnexo.split("/");
                        this.displayAnexo = false;
                        if (contarRutas.length != 1) {
                            this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Tiene que estar en un documento para poder ver las revisiones' });

                        } else {
                            this.displayAnexo = true;
                        }

                    }

                }
            },       */
            {
                label: 'Tablas maestras',
                icon: 'fa fa-file-text',
                items: [
                    {
                        label: 'Territorios', icon: 'pi fa fa-map', command: (): void => {
                            this.dashboardEvent.headerTitle = "territorios";
                            this.router.navigate(['dashboard/territorios']);
                            if (this.isSidebarOpen) {
                                this.isSidebarOpen = !this.isSidebarOpen;
                            }

                        }
                    },
                    {
                        label: 'Variedades', icon: 'pi fa fa-lemon-o', command: (): void => {
                            this.dashboardEvent.headerTitle = "Variedades";
                            this.router.navigate(['dashboard/variedades']);
                            if (this.isSidebarOpen) {
                                this.isSidebarOpen = !this.isSidebarOpen;
                            }

                        }
                    },
                    {
                        label: 'Grupos', icon: 'pi fa fa-users', command: (): void => {
                            this.dashboardEvent.headerTitle = "Grupos";
                            this.router.navigate(['dashboard/grupos']);
                            if (this.isSidebarOpen) {
                                this.isSidebarOpen = !this.isSidebarOpen;
                            }

                        }
                    },                    
                    {
                        label: 'Roles', icon: 'pi fa fa-user', command: (): void => {
                            this.dashboardEvent.headerTitle = "Roles";
                            this.router.navigate(['dashboard/roles']);
                            if (this.isSidebarOpen) {
                                this.isSidebarOpen = !this.isSidebarOpen;
                            }

                        }
                    }
                ]

            },
            {
                label: 'Cerrar Sesión',
                icon: 'fa fa-sign-out',
                command: (): void => {
                    StorageManager.deleteUser();
                    // localStorage.clear();
                    this.router.navigate(['login']);
                }
            },
            {
                label: 'Ver. ' + this.version
                
            }
        ];
    }


    ngOnInit() {
        /**
         *  Imagenes navegar
         */
        this.calidad_imagen = url + 'upload/resource/calidad.png';
        this.certificado = url + 'upload/resource/certificado.png';
        this.fruto_hueso = url + 'upload/resource/fruta_hueso.jpg';
        this.app_stock = url + 'upload/resource/stock.jpg';
        this.app_visitas = url + 'upload/resource/visitas.jpg';
        this.planta = url + 'upload/resources/planta.png';
        /**
         *  Imagenes certificaciones
         */
        this.brcgs = url + 'upload/resource/certificaciones/brcgs.jpg';
        this.enac = url + 'upload/resource/certificaciones/enac.jpeg';
        this.global_gap = url + 'upload/resource/certificaciones/global-gap.png';
        this.ifs = url + 'upload/resource/certificaciones/ifs.png';
        this.igp = url + 'upload/resource/certificaciones/igp.jpg';
        
        this.ImageBaseService.image64(environment.serverUrl + environment.logoUrl).toPromise()
            .then((resp: string) => {

                this.logo = resp;
            })




        this.setOnlineService();
        this.showImage();

        if (sessionStorage.getItem('refresh') === 'true') {
            sessionStorage.setItem('refresh', false.toString());
            window.location.reload();
        }
         
    }

    private setOnlineService() {
        this.isOnline = navigator.onLine;

        window.addEventListener('online', () => {
            this.isOnline = true;
        });

        window.addEventListener('offline', () => {
            this.isOnline = false;
        });
    }

    public onNavItemClick(id: string, item: any) {
        
        if (item.expandable == null   ) {
            this.dashboardEvent.onMenuItemClick(id);
            this.isSidebarOpen = !this.isSidebarOpen;
        } else{
            this.dashboardEvent.onMenuItemClick(id);
           
        }

    }

    public onSubNavItemClick(id: string) {
        // console.log('id', id);

        this.dashboardEvent.onSubmenuItemClick(id);
        this.isSidebarOpen = !this.isSidebarOpen;

    }


    public toggleMenu(menu?: any, $event?: any) {
        //menu.toggle($event);
        this.isSidebarOpen = !this.isSidebarOpen;
    }
    public clickItemMenu($event?: any) {
        //menu.toggle($event);
        this.isSidebarOpen = !this.isSidebarOpen;
    }

    public closeInfoUser(){

    }

    public closeClientDialog() {
        this.showClientDialog = false;
        this.clientHeaderDialog = 'Cambiar cliente';
    }

    public prefsMenu() {
        console.log("Abre preferencias!");
    }

    public exit() {
        StorageManager.deleteUser();
        localStorage.setItem("documentos", null);
        this.dashboardEvent.deleteMenu();

        // localStorage.clear();
        this.router.navigate(['login']);
    }

    public showImage() {
        this.displayImage = false;
        this.expression = false;
        let contarRutas = this.location.path().split("/");
        //let contarArrayRutas=contarRutas.length;

        if (contarRutas.length > 2) {
            this.displayImage = false;
            this.expression = false;

        } else {
            this.displayImage = true;
            this.expression = true;
        }

    }
    public showMySideBar() {


        let contarRutas = this.location.path().split("/");
        //let contarArrayRutas=contarRutas.length;


        if (contarRutas.length > 2) {

            this.isSidebarOpen = false;

        } else {
            this.isSidebarOpen = true;
        }

    }

    restriccionAnexos() {
        this.titleAnexo = this.location.path().replace("/dashboard/", "");
        let contarRutas = this.titleAnexo.split("/");
        this.displayAnexo = false;
        this.displayDocumentacion = false;
        if (contarRutas.length != 1) { }
    }

    public anexos(menu) {
        this.items = [];
        this.titleAnexo = this.location.path().replace("/dashboard/", "");
        let contarRutas = this.titleAnexo.split("/");
        this.displayAnexo = false;
        this.menuItems();
        menu.toggle(event);
        if (localStorage.getItem("role") == "ROLE_ADMIN") {
            //this.menuItems();
            this.menuItemsUser();
            //menu.toggle(event);
            /*        this.items.push({
                       label: 'Usuarios',
                       icon: 'pi pi-fw pi-user',
                       command: (): void => {
                       
                         this.router.navigate(['dashboard/usuarios']);
                     }
                     
                       
                   },{ 
                       label: 'Cerrar Sesión',
                   icon: 'fa fa-sign-out',
                   command: (): void => {
                       StorageManager.deleteUser();
                       this.router.navigate(['login']);
                   }
               }); */
        }
        if (this.location.path().includes('usuarios')) {


        } else {


            if (localStorage.getItem("role") == "ROLE_ADMIN") {
                //this.menuItems();
                this.menuItemsUser();
                //menu.toggle(event);
                /*        this.items.push({
                           label: 'Usuarios',
                           icon: 'pi pi-fw pi-user',
                           command: (): void => {
                           
                             this.router.navigate(['dashboard/usuarios']);
                         }
                         
                           
                       },{ 
                           label: 'Cerrar Sesión',
                       icon: 'fa fa-sign-out',
                       command: (): void => {
                           StorageManager.deleteUser();
                           this.router.navigate(['login']);
                       }
                   }); */
            } else {
                
            }
            
        }


    }


    cerrar() {
        this.displayAnexo = false;
        this.displayDocumentacion = false;
    }

    toDataUrl(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    navegar(value) {
        //this.onSubNavItemClick(value);
        this.isSidebarOpen = false;
        this.router.navigate(['dashboard/' + value]);
    }

    stock() {
       // window.open(' http://traza-brio.com', '_blank');
    }
    visitas() {
       // window.open(' http://traza-brio.com/visitas', '_blank');
    }


    checkRoleUser(){
        if ( localStorage.getItem('role').localeCompare('proveedor') == 0) {
            this.displayDocumentacion = true;
            return true;
        }
        return false;
    }

    checkRoleAdmin(){
        if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0) {
            this.displayDocumentacion = true;
            return true;
        }
        return false;
    }
}
